<template>
  <div class="hello">

    <div id="form" v-if="step<=0">
      <h4 class="font-bold leading-tight text-3xl mt-0 mb-2 text-blue-600"> Cześć z tej strony Bartosz Krych!</h4>
      <h4 class="font-medium leading-tight text-xl mt-0 mb-2 text-black"> Znalazłeś się na tej stronie, ponieważ
        napotkałeś na swojej drodze prośbę o wzięcie udziału w badaniu i wykonaniu ankiety, która pozwoli zbadać pewne
        aspekty programistyczne.</h4>
      <h4 class="font-medium leading-tight text-xl mt-0 mb-2 text-black"> Jednak za nim przejdziemy do szczegółów,
        prosiłbym na początku o odpowiedzenie na jedno proste pytanie...</h4>
      <h2 v-if="step===-1" id="tip" class="font-bold leading-tight text-3xl mt-0 mb-2 text-orange-600">
        Musisz odpowiedzieć na pytanie!
      </h2>
      <div class="rounded-lg" style="border: 1px solid; width: 365px; margin: 30px auto auto;">
        <h3 class="font-medium leading-tight text-2xl mt-0 mb-8 text-black bold">Czy umiesz programować?</h3>
        <div>
          <input v-model="radio" type="radio" id="programmer"
                 name="programmer-vote" value="yes" style="margin-top: 20px">
          <label for="programmer" class="font-medium leading-tight text-xl mt-2 mb-2 ml-2 text-black">Tak</label>
          <br/>
          <input v-model="radio" type="radio" id="no-programmer"
                 name="programmer-vote" value="no" style="margin-top: 20px">
          <label for="no-programmer" class="font-medium leading-tight text-xl mt-2 mb-2 ml-2 text-black">Nie</label>
        </div>
        <div>
          <button
              class="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded"
              style="margin-top: 30px; margin-bottom: 30px" @click="isProgrammer">
            Zatwierdź
          </button>
        </div>
      </div>
    </div>
    <div v-if="step===1">
      <h4 class="font-medium leading-tight text-xl mt-8 mb-2 text-black">
        Dzięki za dobre chęci! Jednak poszukuję osoby, która wie co nieco o programowaniu :)
      </h4>
      <h4 class="font-bold leading-tight text-3xl mt-8 mb-2 text-blue-600">
        Miłego dnia Ci, życzę! :)
      </h4>
    </div>
    <div v-if="step===2" id="programmer-form">
      <h4 class="font-bold leading-tight text-xl mt-8 mb-2 text-black">
        Celem badania jest ocenienie czytelności rozwiązań, które pozwalają przetwarzać np. kolekcje danych w języku
        programowania Java.
      </h4>
      <p class="font-medium leading-tight text-xl mt-6 mb-2 text-black">
        Przygotowane badanie można podzielić na trzy sekcje:
      </p>
      <p class="font-medium leading-tight text-xl mt-0 mb-2 text-black">Sekcja 1 - ma na celu poznanie uczestnika
        badania (3 pytania).</p>
      <p class="font-medium leading-tight text-xl mt-0 mb-2 text-black">Sekcja 2 - ma na celu obiektywną ocenę
        czytelności badanych konstrukcji (6 pytań, w których należy wybrać wartości zwracane dla danego wywołania
        metody). </p>
      <p class="font-medium leading-tight text-xl mt-0 mb-2 text-black">Sekcja 3 - ma na celu subiektywną ocenę
        czytelności badanych konstrukcji (6 pytań, w których należy uporządkować badane konstrukcje od najbardziej do
        najmniej czytelnej).</p>


      <button type="button" @click="handleStartForm"
              class="bg-green-500 hover:bg-green-400 text-white font-bold py-4 px-6 mt-8 border-b-4 border-green-700 hover:border-green-500 rounded"
      >
        Rozpocznij ankietę!
      </button>
    </div>
    <div v-if="step===3">

      <h4 class="font-bold leading-tight text-3xl mt-5 mb-5 text-blue-600"> Cześć z tej strony Bartosz Krych!</h4>

      <h4 class="font-medium leading-tight text-xl mt-5 mb-5 text-black"> Znalazłeś się na tej stronie, ponieważ
        napotkałeś na swojej drodze prośbę o wzięcie udziału w badaniu i wykonaniu ankiety, która pozwoli zbadać pewne
        aspekty programistyczne.</h4>


      <h4 class="font-medium leading-tight text-xl mt-5 mb-5 text-black"> Jednak dobiegł już koniec badania. Teraz przyszedł czas na analizę wyników.
        Jak jesteś zainteresowany jej rezultatami to zapraszam do konktaktu przez <a href="https://www.linkedin.com/in/bartosz-krych-356611116/"> LinkedIn</a> :) </h4>

    </div>
  </div>
</template>

<script>

import db from "@/main";

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      clicks: 0,
      step: 3,
      group: "",
      radio: ""
    }
  },
  methods: {
    isProgrammer() {
      this.step = 0;
      if (this.radio === 'yes') {
        this.step = 2;
      } else if (this.radio === 'no') {
        this.step = 1;
      } else {
        this.step = -1;
      }
    },
    async handleStartForm() {
      await db.collection("counter")
          .doc("counter")
          .get()
          .then((b) => {
            this.clicks = b.data().iteration
          })
          .catch((error) => {
            console.error("Error getting doc: ", error);
          });

      const routing = this.clicks % 3;

      this.clicks += 1;

      await db.collection("counter")
          .doc("counter")
          .update({
            iteration: this.clicks,
          })
          .catch((error) => {
            console.error("Error updating doc: ", error);
          });

      if (routing === 0) {
        window.location.replace("https://forms.office.com/r/LdNSzsVY0Z")
      } else if (routing === 1) {
        window.location.replace("https://forms.office.com/r/8Qr0EZ1QrN")
      } else {
        window.location.replace("https://forms.office.com/r/TZVAYgQ0Fp")
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
